import styled from 'styled-components'
import tw from 'twin.macro'
import ProgressBar from 'components/Common/ProgressBar'

export const Container = styled.div`
  ${tw`bg-white rounded-2xl border border-background-hover`}
  ${tw`xs:px-4 xs:pt-5 xs:pb-8 xs:mx-4 sm:mx-0 md:px-8 md:pt-6 md:pb-10`}
  ${tw`flex`}
  box-shadow: 0px 16px 32px -16px #00000014, 0px 12px 24px -12px #0000001F;
`
export const AvatarColumn = styled.div`
  ${tw`flex items-start w-16`}
`

export const InfoColumn = styled.div`
  ${tw`flex flex-col flex-1 `}
  ${tw`ml-4`}
`

export const TitleRow = styled.div`
  ${tw`flex justify-between items-center`}
`
export const Title = styled.h1`
  ${tw`text-2xl font-medium font-inter`}
`

export const Description = styled.p`
  ${tw`text-sm font-normal leading-5 text-primary-disabledTextLight`}
`

export const ProgressContainer = styled.div`
  ${tw` mt-2`}
`

export const ProgressText = styled.p`
  ${tw`text-right text-sm font-normal text-primary-disabledTextLight`}
`

export const StyledProgressBar = styled(ProgressBar)`
  ${tw`bg-primary-appBrand rounded-s-3xl !rounded-e-none`}
`
